import { useEffect } from "react";
import { useSim } from "../lib/store";
import { startHaptics, stopHaptics } from "../lib/haptics";

// Drives real device vibration during a simulation: Aerial 'Thrum' vs Street 'Shake'.
// Intensity aggregates across simultaneous events (strongest event drives the pattern).
export function HapticsEngine() {
  const simulating = useSim((s) => s.simulating);
  const viewMode = useSim((s) => s.viewMode);
  const events = useSim((s) => s.events);
  const magnitude = useSim((s) => s.magnitude);

  const maxMag = events.length ? Math.max(...events.map((e) => e.magnitude)) : magnitude;

  useEffect(() => {
    if (simulating) {
      startHaptics(maxMag, viewMode === "street" ? "street" : "aerial");
    } else {
      stopHaptics();
    }
    return () => stopHaptics();
  }, [simulating, viewMode, maxMag]);

  return null;
}
